import { FETCH_INFO } from "../types";

const initialState = {
  info: [],
};

const infoReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INFO:
      return {
        ...state,
        info: action.data,
      };
    default:
      return state;
  }
};

export default infoReducer;
